/* eslint-disable max-lines */
/* eslint-disable sort-keys */

import {API_VERSION} from 'core/helpers/env';

export const WINE_SHOPS_FILTERS_CODES = {
    PICKUP: 'pick_up',
    BOOK: 'to_book',
};

export const WINE_SHOPS_STOCK_TYPES_CODES = {
    BY_SIMPLE: 'by_simple',
};

export const CENTRAL_WAREHOUSE_CODE = 'central_warehouse';

export const WEEKEND = 'выходной';

export const INITIAL_SHOPS_SHOW_COUNT = 3;

export const WINESHOPS_LIST_VIEW = {
    page: 'page',
    filter: 'filter',
} as const;

export const ENDPOINT_WINESHOPS = `${API_VERSION}/wineries`;
